"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEntityAndFile = void 0;
const Constants_1 = require("../Constants");
const Hashing_1 = require("./Hashing");
/**
 * Take all the entity's data, build the entity file with it, and calculate its id
 */
async function buildEntityAndFile(type, pointers, timestamp, content, metadata) {
    // Make sure that there is at least one pointer
    if (pointers.length === 0) {
        throw new Error(`All entities must have at least one pointer.`);
    }
    const entity = {
        type,
        pointers,
        timestamp,
        content,
        metadata
    };
    const entityFile = { name: Constants_1.ENTITY_FILE_NAME, content: Buffer.from(JSON.stringify(entity)) };
    const entityId = await Hashing_1.Hashing.calculateHash(entityFile);
    const entityWithId = Object.assign({ id: entityId }, entity);
    return { entity: entityWithId, entityFile };
}
exports.buildEntityAndFile = buildEntityAndFile;
//# sourceMappingURL=EntityFactory.js.map